<ion-item lines="full" [disabled]="disabled" [counter]="maxCharacters">
  <div class="textarea" *ngIf="textarea || readonly; else ionInput">
      <ion-label [position]="labelPlacement">
        {{label}}
      </ion-label>
    <ion-textarea [value]="value" (ionInput)="onInputChange($event)" [readonly]="readonly"
                  auto-grow="true" [maxlength]="maxCharacters">
    </ion-textarea>
  </div>

  <ng-template #ionInput>
      <ion-label [position]="labelPlacement">
          {{label}}
      </ion-label>
    <ion-input [value]="value"
               (ionInput)="onInputChange($event)"
               [readonly]="readonly" [maxlength]="maxCharacters"
               [type]="type">
    </ion-input>
  </ng-template>
</ion-item>
